export default __webpack_public_path__ + "static/media/compressor-inactive.218e1adf.svg";